import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserService } from './services/user.service';
import { TankService } from './services/tank.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private tankService: TankService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.userService.loggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }

    if (route.data && route.data.skipWebAccessCheck) {
      return true;
    }

    const user = this.userService.currentUser;
    if (user.role === 'superadmin') {
      return true;
    }

    if (!this.tankService.isWebAccessEnabled(this.tankService.currentTank)) {
      this.router.navigate(['/web-access-disabled']);
      return false;
    }

    return true;
  }
}
